import { Typography } from '@mui/material'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import Card from '@mui/material/Card'
import CardActions from '@mui/material/CardActions'
import CardContent from '@mui/material/CardContent'
import FormControl from '@mui/material/FormControl'
import FormHelperText from '@mui/material/FormHelperText'
import Grid from '@mui/material/Grid'
import InputLabel from '@mui/material/InputLabel'
import MenuItem from '@mui/material/MenuItem'
import Select from '@mui/material/Select'
import TextField from '@mui/material/TextField'
import { useEffect, useState } from 'react'
import { Controller, useForm } from 'react-hook-form'
import toast from 'react-hot-toast'
import { useNavigate, useParams } from 'react-router-dom'
import { apiService } from '../../api/axiosClient'
import Page from '../../components/Page'
import Editor from '../../components/editor'

const Faq = () => {
    const params = useParams();
    const navigate = useNavigate();
    const [faq, setFaq] = useState();
    const [content, setContent] = useState('')
    const {
        control,
        handleSubmit,
        formState: { errors },
        reset,
    } = useForm()

    useEffect(() => {
        const fetchData = async () => {
            const response = await apiService.get(`/faqs/${params.id}`)
            const payload = response.data;

            setFaq(payload.data);
        }

        fetchData().catch(e => console.error(e));
    }, [params.id])

    useEffect(() => {
        const defaultValues = {
            type: faq?.type,
            title: faq?.title,
        }
        reset(defaultValues)

        setContent(faq?.descript)

    }, [reset, faq])

    const goBack = () => {
        navigate(-1)
    }

    const onSubmit = async (data, e) => {
        const params = {
            "type": data.type,
            "title": data.title,
            "descript": content,
        };

        await apiService.put(`/faqs/${faq.qid}`, params)
        .then(response => {
            toast.success('수정 되었습니다')
            goBack()
        }).catch(error => {
            // 에러는 이제 axiosClient의 interceptor에서 자동으로 처리됩니다
            console.error('API Error:', error);
        })
    }

    return (
        <Page title="Faq">
            <Card>
                <form onSubmit={handleSubmit(onSubmit)} id="qform">
                    <CardContent sx={{ pt: 8 }}>
                        <Box sx={{ mb: 9, textAlign: 'center' }}>
                            <Typography variant='h5' sx={{ mb: 3, lineHeight: '2rem' }}>
                                FAQ
                            </Typography>
                        </Box>

                        <Grid container spacing={6}>
                            <Grid item xs={12} md={6} lg={4}>
                                <FormControl fullWidth>
                                    <InputLabel id='type'>질문유형</InputLabel>
                                    <Controller
                                        name='type'
                                        control={control}
                                        rules={{ required: true }}
                                        defaultValue=""
                                        renderValue={selected => (selected.length === 0 ? '' : selected)}
                                        render={({ field: { value, onChange } }) => (
                                            <Select
                                                label='질문유형'
                                                value={value}
                                                onChange={onChange}
                                                labelId='type'
                                                error={Boolean(errors.type)}
                                                variant="standard"
                                            >
                                                <MenuItem value="취소/환불/교환">취소/환불/교환</MenuItem>
                                                <MenuItem value="배송문의">배송문의</MenuItem>
                                                <MenuItem value="기타문의">기타문의</MenuItem>
                                            </Select>
                                        )}
                                    />
                                    {errors.type && (
                                        <FormHelperText sx={{ color: 'error.main' }} id='validation-async-type'>
                                            필수
                                        </FormHelperText>
                                    )}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12}>
                                <FormControl fullWidth>
                                    <Controller
                                        name='title'
                                        control={control}
                                        rules={{ required: true }}
                                        defaultValue=""
                                        render={({ field: { value, onChange } }) => (
                                            <TextField
                                                value={value}
                                                label='회신'
                                                id='title'
                                                onChange={onChange}
                                                placeholder='제목을 입력해주세요'
                                                error={Boolean(errors.title)}
                                                aria-describedby='validation-async-title'
                                                variant="standard"
                                            />
                                        )}
                                    />
                                    {errors.title && (
                                        <FormHelperText sx={{ color: 'error.main' }} id='validation-async-title'>
                                            필수
                                        </FormHelperText>
                                    )}
                                </FormControl>
                            </Grid>

                            <Grid item xs={12}>
                                <Editor content={content} setContent={setContent} />
                            </Grid>

                        </Grid>
                    </CardContent>
                </form>

                <CardActions className='card-action'>
                    <Button type="submit" form="qform" variant='contained'> 수정 </Button>
                    <Button variant='outlined' color='secondary' onClick={goBack}> 취소 </Button>
                </CardActions>
            </Card>
        </Page>
    )
}

export default Faq